import { useEffect } from 'react';
import deviceMetadataManager from '../../utils/deviceMetadata';

const DeviceMetadataTracker = () => {
  useEffect(() => {
    // Initialize metadata collection on component mount
    deviceMetadataManager.initialize();

    // Listen for visibility change to detect when user returns to tab
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        deviceMetadataManager.initialize();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default DeviceMetadataTracker;